// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ynbhealthcare-jobs.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://ynbhealthcare-jobs.onrender.com/";
export const shopurl = "https://thejobship.com/";
export const mainurl = "https://thejobship.com/";
export const fronturl = "https://thejobship.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;
